import { render, staticRenderFns } from "./DetailBundleInGudangkuDetail.vue?vue&type=template&id=57d5401d&"
import script from "./DetailBundleInGudangkuDetail.vue?vue&type=script&lang=js&"
export * from "./DetailBundleInGudangkuDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports